// soglia/sogliaExit sono parametriche: nel primo anno di attività arrivano ragguagliate
// ai giorni effettivi (vedi getSogliePerAnno in fiscalEngine).
export function simulaSuperamentoSoglia(incassiAttuali, fatturaIpotetica, coefficiente, aliquota, inpsRate, costiDeducibili = 0, soglia = 85000, sogliaExit = 100000) {
  const nuovoTotale = incassiAttuali + fatturaIpotetica;
  const formatEuroSoglia = (v) => Math.round(v).toLocaleString('it-IT') + '€';

  let scenario = {
    incassiAttuali,
    fatturaIpotetica,
    nuovoTotale,
    status: 'OK',
    message: '',
    dettagli: {}
  };

  if (nuovoTotale > sogliaExit) {
    scenario.status = 'CRITICAL';
    scenario.message = `Superi ${formatEuroSoglia(sogliaExit)}: esci dal forfettario IMMEDIATAMENTE. Devi applicare IVA dalla prossima fattura.`;
    scenario.dettagli = {
      uscita: 'IMMEDIATA',
      ivaObbligatoria: true,
      daFattura: `Dalla fattura che fa superare i ${formatEuroSoglia(sogliaExit)}`
    };
  } else if (nuovoTotale > soglia) {
    scenario.status = 'WARNING';
    scenario.message = `Superi ${formatEuroSoglia(soglia)}: esci dal forfettario dall'anno prossimo. Quest'anno completi normalmente.`;
    scenario.dettagli = {
      uscita: 'ANNO_PROSSIMO',
      ivaObbligatoria: false,
      annoUscita: new Date().getFullYear() + 1
    };
  } else if (nuovoTotale > soglia * (75 / 85)) {
    scenario.status = 'CAUTION';
    scenario.message = `Sei all'${((nuovoTotale / soglia) * 100).toFixed(0)}% della soglia. Margine: ${formatEuroSoglia(soglia - nuovoTotale)}`;
  }

  // Calcolo tasse forfettario
  const imponibile = nuovoTotale * coefficiente;
  const inps = imponibile * inpsRate;
  const imposta = (imponibile - inps) * aliquota;

  scenario.tasseForfettario = {
    imponibile,
    inps,
    imposta,
    totale: inps + imposta,
    netto: nuovoTotale - inps - imposta
  };

  // Se supera soglia, calcola anche ordinario
  if (nuovoTotale > soglia) {
    scenario.tasseOrdinario = calcolaRegimeOrdinario(nuovoTotale, costiDeducibili);
    scenario.differenzaNetto = scenario.tasseForfettario.netto - scenario.tasseOrdinario.netto;
  }

  return scenario;
}

export function calcolaRegimeOrdinario(ricavi, costiDeducibili) {
  const reddito = ricavi - costiDeducibili;
  const inps = reddito * 0.2607;
  const imponibileIrpef = reddito - inps;

  // IRPEF a scaglioni
  let irpef = 0;
  if (imponibileIrpef <= 28000) {
    irpef = imponibileIrpef * 0.23;
  } else if (imponibileIrpef <= 50000) {
    irpef = 28000 * 0.23 + (imponibileIrpef - 28000) * 0.35;
  } else {
    irpef = 28000 * 0.23 + 22000 * 0.35 + (imponibileIrpef - 50000) * 0.43;
  }

  // Addizionali stimate (regionale ~1.7%, comunale ~0.5%)
  const addizionali = imponibileIrpef * 0.022;

  const totaleTasse = irpef + addizionali + inps;

  return {
    reddito,
    inps,
    irpef,
    addizionali,
    totale: totaleTasse,
    netto: ricavi - costiDeducibili - totaleTasse,
    aliquotaEffettiva: ((totaleTasse / ricavi) * 100).toFixed(1) + '%'
  };
}
